import store from '@/store';

export function checkIfOnline() {
  window.addEventListener('load', () => {
    function handleNetworkChange() {
      if (navigator.onLine) {
        store.commit('system/setOnline');
      } else {
        store.commit('system/setOffline');
      }
    }

    window.addEventListener('online', handleNetworkChange);
    window.addEventListener('offline', handleNetworkChange);
    handleNetworkChange();
  });
}
